import { Injectable } from '@angular/core';
import { HeaderConfigService } from '@core/config/header-config.service';
import { CallSubType, CallType, GenesysData } from '@shared/interfaces/CallLog';
import { BehaviorSubject, Observable } from 'rxjs';
import { GenesysIconsStates } from '../enums/Icons';
import { GenesysBridgeService } from './genesys-bridge.service';
import { GenesysContactFinder } from './genesys-contact-finder.service';

@Injectable({
  providedIn: 'root',
})
export class GenesysTelephonyService {
  public showGenesysTelephony$ = new BehaviorSubject<boolean>(false);
  public showIncomingCallNotification$ = new BehaviorSubject<boolean>(false);

  constructor(
    public headerConfigService: HeaderConfigService,
    private genesysBridgeService: GenesysBridgeService,
    private readonly genesysContactFinder: GenesysContactFinder
  ) {}

  public getGenesysTelephony(): Observable<any> {
    return this.showGenesysTelephony$.asObservable();
  }

  public showGenesysTelephony(): void {
    this.showGenesysTelephony$.next(true);
  }

  public hideGenesysTelephony(): void {
    this.showGenesysTelephony$.next(false);
  }

  public getIncomingCallNotification(): Observable<any> {
    return this.showIncomingCallNotification$.asObservable();
  }

  public showIncomingCallNotification(): void {
    this.showIncomingCallNotification$.next(true);
  }

  public hideIncomingCallNotification(): void {
    this.showIncomingCallNotification$.next(false);
  }

  public makePhoneCall(args: any): void {
    this.genesysBridgeService.clickToDial('call', args);
  }

  public sendSms(args: any): void {
    this.genesysBridgeService.clickToDial('sms', args);
  }

  public setGenesysTelephonyIcon(type: string): void {
    const toolbarOption = this.headerConfigService.toolbarOptions.find(
      (element) => element.action === 'genesys_telephony'
    );
    toolbarOption.customSVG = (
      this.switchGenesysTelephonyIcon[type] || GenesysIconsStates['default']
    )(type);
  }

  // todo this needs to be done in the contact find service or somewhere where
  // its synchronous with the request of the data

  public buildGenesysInteractionData(interaction: any) {
    const genesysData: GenesysData = {
      callID: interaction.id,
      phoneNumber: interaction.calledNumber,
      callType: CallType.Outbound,
      callSubType: interaction.isDialer
        ? CallSubType.Dialler
        : CallSubType.Agent,
    };

    if (this.isCallFromDialerCampaign(interaction)) {
      genesysData.ani = interaction.ani;
      genesysData.dialerCampaignId = interaction.dialerCampaignId;
      genesysData.dialerContactId = interaction.dialerContactId;
      genesysData.dialerContactListId = interaction.dialerContactListId;
      genesysData.phoneNumber = this.normalizePhoneNumber(interaction.phone);

      this.genesysContactFinder.findContactInformation({
        contactId: interaction.dialerContactId,
        contactListId: interaction.dialerContactListId,
      });
    }

    return genesysData;
  }

  private isCallFromDialerCampaign(interaction: any) {
    return interaction.ani !== 'Internal' && interaction.isDialer;
  }

  private normalizePhoneNumber(phone: string): string {
    const number = phone.split('tel:')[1] || phone;
    return number.startsWith('+44') ? number.replace('+44', '') : number;
  }

  private switchGenesysTelephonyIcon = {
    default: () => GenesysIconsStates.DEFAULT,
    selected: () => GenesysIconsStates.SELECTED,
    incoming: () => GenesysIconsStates.INCOMING,
    dialing: () => GenesysIconsStates.DIALLING,
  };
}
